<template>
  <div class="animated revealUp">
    <!-- SEND EMAIL MODAL -->
    <!-- <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      ref="sendEmail"
    >
      <h5
        class="font-weight-bold text-blue text-center"
      >Are you sure you want to send this invoice to vendor?</h5>
      <div class="d-flex mx-auto">
        <button
          :disabled="disableYesButton"
          @click.prevent="onClickYes()"
          class="btn-blue"
          title="Yes"
        >Yes</button>
        <button @click.prevent="onClickNo()" class="btn-blue" title="No">No</button>
      </div>
    </b-modal> -->
    <!-- SEND EMAIL MODAL -->

    <!-- <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view')}} {{ $t('purchase') }} {{ $t('order') }}</div>
      <div class="d-flex">
        <button @click.prevent="openConfirmEmailModal()" class="btn-blue" title="Send Email">
          <img src="@/assets/img/icons/email.png" height="auto" width="25" />
        </button>
        <a
          v-if="getPurchaseOrderFileName"
          :href="BASE_URL+getPurchaseOrderFileName"
          target="_blank"
          download
          class="btn-transparent"
          title="Download as PDF"
        >
          <button v-if="getPurchaseOrderFileName" class="btn-blue" title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="auto" width="25" />
          </button>
        </a>
        <router-link
          class="btn-blue mx-2"
          :to="'/fnb/edit-purchase-order?po_number='+purchasOrderDetails.po_number+'&po_id='+purchasOrderDetails.po_id"
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="/fnb/purchase-order"
        >{{ $t('purchase') }} {{ $t('order') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div> -->

    <div class="white-wrapper">
      <caption class="text-nowrap font-weight-bold">{{'FnB Order Details'}}</caption>
      <table border="1" style="width:100%;margin-bottom:50px;">
        <tbody>
          <tr style="vertical-align:top;">
            <td style="width:50%;padding:5px;">
              <tr>
                <strong style="font-size:16px;">Order Code : {{transactionList[0].order_code}}</strong>
              </tr>
              <tr>Service Option : {{transactionList[0].fat_service_option}}</tr>
              <!-- <tr>[City, ST ZIP]</tr> -->
              <tr>Status : {{ transactionList[0].fat_status }}</tr>
              <!-- <tr>Fax: (000) 000-0000</tr> -->
              <!-- <tr>Website:</tr> -->
            </td>
            <td style="padding:5px;">
              <tr>{{ 'Transaction Date' }}: {{ dateParse(transactionList[0].ft_date_time) }}</tr>
              <tr>{{ 'Delivery Date' }}: {{ dateParse(transactionList[0].fnb_delivery_datetime) }}</tr>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <table border="1" style="width:100%;margin-bottom:50px;">
        <thead style="background:#3876d2; color: white; text-align: center;">
          <tr>
            <th style="width:50%;padding:5px;">VENDOR</th>
            <th style="width:50%;padding:5px;">SHIP TO</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style="padding:5px;"
            >Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum harum iure fuga velit voluptatem officiis reprehenderit voluptatibus omnis, nisi numquam facere excepturi illum, eius architecto eos quisquam quas! Quis, magnam.</td>
            <td style="padding:5px;"></td>
          </tr>
        </tbody>
      </table>-->

      <!-- <table border="1" style="width:100%;margin-bottom:50px;">
        <thead style="background:#3876d2; color: #fff; text-align: center;">
          <tr>
            <th style="padding:5px">REQUISITIONER</th>
            <th style="padding:5px">SHIP VIA</th>
            <th style="padding:5px">F.O.B.</th>
            <th style="padding:5px">SHIPPING TERMS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>-->

      <table border="1" style="width:100%;margin-bottom:20px;">
        <thead style="background:#3876d2; color: #fff; text-align: center;">
          <tr>
            <th style="padding:5px; text-transform: uppercase;">{{ $t('items') }}</th>
            <!-- <th style="padding:5px; text-transform: uppercase;">{{ $t('description') }}</th> -->
            <th style="padding:5px; text-transform: uppercase;">QTY</th>
            <!-- <th style="padding:5px; text-transform: uppercase;">UOM</th> -->
            <th
              style="padding:5px; text-transform: uppercase;"
            >{{ $t('unit') }} {{ $tc('price', 1) }}</th>
            <th style="padding:5px; text-transform: uppercase;">TOTAL</th>
          </tr>
        </thead>
        <tbody v-for="(transaction, transactionKey) in transactionList" :key="transactionKey" style="text-align:center;">
          <tr>
            <td rowspan="5">{{ transaction.fat_item_name }}</td>
            <!-- <td>{{ raw.rm_description }}</td> -->
            <td rowspan="5">{{ transaction.fat_quantity }}</td>
            <td>{{ (transaction.fnb_net_amount/transaction.fat_quantity).toFixed(2) }}</td>
            <td>{{ transaction.fnb_net_amount.toFixed(2) }}</td>
            <!-- <td>{{ raw.poi_price }}</td> -->
          </tr>
          <tr >
            
            <td style="text-transform: uppercase;">{{ $t('subtotal') }}</td>
            <td style="font-weight:bold;">{{ transaction.fnb_net_amount.toFixed(2) }}</td>
          </tr>
          
          <tr >
            <td style="text-transform: uppercase;">{{ $t('tax') }}</td>
            <td>{{ (transaction.fnb_total_amount - transaction.fnb_net_amount).toFixed(2)  }}</td>
          </tr>
          <tr >
            <td>
              <strong style="text-transform: uppercase;">TOTAL</strong>
            </td>
            <td>
              <strong>{{transaction.ft_currency_name}} {{ transaction.fnb_total_amount.toFixed(2) }}</strong>
            </td>
          </tr>
        </tbody>
         <tbody style="text-align:center;">
         <tr>
            <td rowspan="4" colspan="2"></td>
          </tr>
              <tr >
            <td>
              <strong style="text-transform: uppercase;">Offer Price</strong>
            </td>
            <td>
              <strong>{{transactionList[0].ft_currency_name}} {{ transactionList[0].ft_offer_price.toFixed(2) }}</strong>
            </td>
          </tr>
            <tr >
            <td>
              <strong style="text-transform: uppercase;">Grand Total</strong>
            </td>
            <td>
              <strong>{{transactionList[0].ft_currency_name}} {{ transactionList[0].ft_total_amount.toFixed(2) }}</strong>
            </td>
          </tr>
         </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import moment from "moment";
export default {
  data() {
    return {
    transactionList:[]
     
    
    };
  },
  beforeMount() {
  },
  mounted() {
    const { ft_id } = this.$route.params;
    console.log('ft_id :>> ', ft_id);
    if(ft_id){
    this.getTransactionDetails(ft_id);
    }
  },
  methods: {
      dateParse(date){
         return moment(date).format('DD-MMM-YYYY HH:mm')
      },
    getTransactionDetails(ft_id) {
    //   const { ft_id } = this.$route.params;
      PosFnbService.GetFnBAppTransactionDetails({
        ft_id: ft_id
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.transactionList = data.Records;
            console.log('this.transactionList :>> ', this.transactionList);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
  }
};
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBOrdersComponent/viewFnBAppTransaction.vue